import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { HttpParams } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-vending-donation-settlements",
  templateUrl: "./vending-donation-settlements.component.html",
  styleUrls: ["./vending-donation-settlements.component.css"],
})
export class VendingDonationSettlementsComponent implements OnInit {
  donation: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  currency: string = localStorage.getItem("CUR") || "SEK";
  loading: boolean = false;
  selectedDonation: any;
  selectedStatus: string = '';

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.getDonation();
  }

  getDonation(): void {
    this.loading = true;
    const user_id = this.globals.user._id;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;

    let params = new HttpParams()
      .set("operator_id", user_id)
      .set("page", pageIndex.toString())
      .set("limit", this.pageSize.toString());

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        `${ConfigApi.URLS.VENDING_DONATION_SETTLEMENT.LIST
        }?${params.toString()}`
      )
      .subscribe(
        (res) => {
          this.loading = false;
          if (this.apiCallingService.handleSuccess(res)) {
            this.donation = res.data;
            this.totalCount = res.total;
          }
        },
        (error) => {
          this.loading = false;
          this.toastr.error("Failed to load donations");
        }
      );
  }

  loadPage(page: number): void {
    if (page) {
      this.page = page;
      this.getDonation();
    }
  }
  updateStatus(item: any, status: string): void {
    if (item.status === status) return;

    const payload = { status };

    this.apiCallingService
      .callAPI(
        payload,
        "PUT",
        `${ConfigApi.URLS.VENDING_DONATION_SETTLEMENT.UPDATE}/${item._id}`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Status updated successfully");
            item.status = status; // UI update
          }
        },
        () => {
          this.toastr.error("Failed to update status");
        }
      );
  }

  openConfirmModal(content: any, val: any, status: string) {
    this.selectedDonation = val;
    this.selectedStatus = status;
    this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  confirmStatus(modal: any) {
    this.updateStatus(this.selectedDonation, this.selectedStatus);
    modal.close();
  }

  viewDonationDetails(val: any): void {
    this.router.navigate(["/user/charity-settlements", val._id]);
  }
}
